import React, { Component } from "react";
import { Row, Col, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Calendar from "components/Common/Calendar/Calendar";
import moment from "moment";
import _ from "lodash";
import { getDate } from "../../../../libraries/form/utilities/dateParser";
import "./style.css";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { ToastService } from "../../../../utils/toastify";
import { languageService } from "../../../../Language/language.service";

const HosDateView = ({ fullDate, data, clickHandler, dateCellProps }) => {
  // dateCellProps && console.log(JSON.stringify(dateCellProps));
  const validDate = getDate(fullDate);
  if (!validDate) return null;

  if (!dateCellProps || !dateCellProps.effectiveDate) return null;
  let hosForDate = {};
  if (Array.isArray(data) && data.length > 0) {
    hosForDate = data[0];
  }

  let isInFuture = false;
  let isInPast = false;
  const { effectiveDate, timezone, latestHosRecord, offDays, lastOffDay } = dateCellProps;
  let className = "missing";
  let display = "Missing";
  let fullySubmitted = false;
  let partialSubmitted = false;
  let offDay = false;
  let notReported = false;

  let today = moment.tz(timezone);

  let currentDate = moment.tz(validDate, timezone);
  const currDateStart = currentDate.clone().startOf("day");
  const currDateEnd = currentDate.clone().endOf("day");
  let offDayFound = offDays.find((offDay) => currDateStart.isSame(offDay.date));
  isInFuture = currDateEnd.isAfter(today.endOf("day"));
  fullySubmitted = latestHosRecord && currDateEnd.isSameOrBefore(new Date(latestHosRecord.endDate));
  partialSubmitted =
    latestHosRecord && currDateStart.isBefore(new Date(latestHosRecord.endDate)) && currDateEnd.isAfter(new Date(latestHosRecord.endDate));
  if (currDateStart.isBefore(effectiveDate)) {
    className = "past";
    display = "";
    isInPast = true;
  } else if (offDayFound) {
    className = "offday";
    display = offDayFound.activityType && offDayFound.activityType.value ? offDayFound.activityType.value : "Off Day";
    offDay = true;
  } else if (isInFuture) {
    className = "future";
    display = "";
  } else if (
    // the current date is before the last submitted hos record date
    fullySubmitted
  ) {
    className = "submitted";
    display = "Submitted";
  } else if (partialSubmitted) {
    className = "in-progress";
    display = "In Progress";
  } else if (lastOffDay && currDateStart.isSameOrBefore(lastOffDay)) {
    // this day is before the last reported Off Duty
    notReported = true;
  }

  return (
    <div
      className={`hos-date-view ${className}`}
      onClick={() => {
        !isInPast && !isInFuture && clickHandler && clickHandler({ date: fullDate, submitted: fullySubmitted });
      }}
    >
      {(fullySubmitted || partialSubmitted) && !isInPast && !isInFuture && (
        <div className={`submitted-icon ${fullySubmitted ? "full" : "partial"}`}>✓</div>
      )}
      {languageService(display)}
    </div>
  );
};

class HosCalendarView extends Component {
  constructor(props) {
    super(props);
    this.state = { cal_data: [] };
  }

  render() {
    const { offDays, effectiveDate, latestHosRecord, timezone } = this.props;
    let lastOffDay = null;
    if (offDays.length > 0) {
      lastOffDay = moment.max(offDays.map((offDay) => offDay.date));
    }
    return (
      <Col md="12">
        <Calendar
          className={"hos-calendar-view"}
          dateCellProps={{
            effectiveDate: effectiveDate,
            latestHosRecord: latestHosRecord,
            timezone: timezone,
            offDays: offDays,
            lastOffDay: lastOffDay,
          }}
          getDateControls={this.props.getDateControls}
          getCurrentDate={this.props.getHosRecordsForMonth}
          data={this.props.hosRecords}
          timezone={this.props.timezone}
          dataDateProperty={"date"}
          reCalculateDataCaller={() => {}}
          selfCalculate={true}
          dateCellComponent={HosDateView}
          dateCellClickHandler={this.props.openHosDataDialog}
          version={null}
          selectionListData={[]}
          userList={[]}
          updateSelectionData={() => {}}
          handleViewItem={() => {}}
          // initial calendar settings
          calendarMonth={this.props.calendarMonth}
          calendarYear={this.props.calendarYear}
        />
      </Col>
    );
  }
}

export default HosCalendarView;



// WEBPACK FOOTER //
// ./src/components/HoursOfService/Helper/HosCalendarView/index.jsx